import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 74FE9D86-D461-4C92-8981-E5A67954D6FA
 * name layers-plus
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/layers-plus.svg
 * tags
 * - Geographic Information System 
 */
export const LayersPlusIcon = createSvgIcon(<><path d="M17,14H19V17H22V19H19V22H17V19H14V17H17V14M11,16L2,9L11,2L20,9L11,16M11,18.54L12,17.75V18C12,18.71 12.12,19.39 12.35,20L11,21.07L2,14.07L3.62,12.81L11,18.54Z" /></>, 'LayersPlusIcon');
export default LayersPlusIcon